import { Component, OnInit, Input, AfterViewInit } from "@angular/core";
import videojs from "video.js";
import canauto from "can-autoplay";
import { MediaService } from "../../services/media.service";
import { Store } from "@ngrx/store";
import { filter, map } from "rxjs/operators";

@Component({
  selector: "app-audio",
  templateUrl: "./audio.component.html",
  styleUrls: ["./audio.component.scss"],
})
export class AudioComponent implements OnInit, AfterViewInit {
  @Input() data: any = {};
  public vjs: videojs.Player;
  baseUrl = "";

  constructor(private store: Store, private media: MediaService) {}

  ngOnInit() {
    this.store
      .pipe(
        map((store: any) => store.state),
        filter((state: any) => state.config !== null)
      )
      .subscribe((state: any) => {
        if (state.config.baseUrl) {
          this.baseUrl = state.config.baseUrl;
        } else {
          this.baseUrl = "../../../assets/media-content/";
        }
      });
  }

  ngAfterViewInit() {
    const options = {
      sources: [
        {
          src: this.src,
          type: "audio/mp3",
        },
      ],
      poster: this.poster,
      responsive: true,
      fluid: true,
      autoplay: true,
    };
    this.vjs = videojs("player", options);
    canauto.video().then(({ result }) => {
      if (result === true) {
        const play = this.vjs.play();
        play.catch((error) => console.error(error));
      }
    });

    this.vjs.on("ended", () => {
      let completed = this.vjs.ended();
      let mediaObject = {
        value: completed,
      };
      this.media.set(mediaObject);
    });
  }

  get src() {
    return this.baseUrl + this.data.course + "/audio/" + this.data.audio[0];
  }
  get poster() {
    return this.baseUrl + this.data.course + "/image/" + this.data.image[0];
  }
}
